export const replaceEmptyToNull = (obj) => {
  return Object.keys(obj).reduce((acc, key) => {
    acc[key] =
      typeof obj[key] === "string" && obj[key].trim() === "" ? null : obj[key];
    return acc;
  }, {});
};
